<template>
  <div v-if="isVisible" class="modal-overlay" @click="close">
    <div @click.stop class="modal-content">
      <div class="modal-header">
        <h2>{{ title }}</h2>
        <button @click="close" class="close-button">
          <i class="fas fa-times text-white"></i>
        </button>
      </div>

      <div class="modal-body">
        <p>{{ content }}</p>
      </div>

      <div class="modal-footer">
        <button @click="close" class="modal-footer-button">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    closeModal: Function,
  },
  methods: {
    close() {
      this.closeModal();
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 98765432100;
}

.modal-content {
  background: linear-gradient(145deg, #1a2942, #0f1825);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-height: 85vh;
  max-width: 500px;
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.close-button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  span {
    position: absolute;
    width: 14px;
    height: 1px;
    background: white;
    transform-origin: center;

    &:first-child {
      transform: rotate(45deg);
    }

    &:last-child {
      transform: rotate(-45deg);
    }
  }
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
}

.modal-close-button {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.modal-close-button:hover {
  color: #ff4d4d;
}

.modal-body {
  margin: 20px 0;
  overflow: auto;
}

.modal-body p {
  font-size: 16px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer-button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.modal-footer-button:hover {
  background-color: #45a049;
}
</style>
